import request from '@/CommonDP/utils/request';

export default {
  getProjectList(params) {
    return request.post('/project/list', params);
  },
  getActivationPrjPage(params) {
    return request.post('/activation/getPrjPage', params);
  },
  getInspectionReport(params) {
    return request.post('/activation/getInspectionReport', params);
  },
  activationExportPrj(params1) {
    return request({
      responseType: 'blob',
      url: '/activation/exportPrj',
      method: 'post',
      data: params1
    });
  },
  InspectionReportExport(params1) {
    return request({
      responseType: 'blob',
      url: '/activation/exportInspectionReport',
      method: 'post',
      data: params1
    });
  }

};
